export default "__VITE_ASSET__BMZViUUw__"